export const CloseCircleIcon = (props) => (
  <svg
    {...props}
    width={props?.width || '20'}
    height={props?.height || '20'}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 4.5L4.5 7.5M4.5 4.5L7.5 7.5M11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6Z"
      stroke={props?.color || '#F79009'}
      strokeWidth={props?.border || '2'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
